// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PasswordBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6 7v18a1.5 1.5 0 0 1-3 0V7a1.5 1.5 0 0 1 3 0Zm10.341 6.338-1.841.597V12a1.5 1.5 0 1 0-3 0v1.935l-1.841-.598a1.502 1.502 0 0 0-1.993 1.543 1.5 1.5 0 0 0 1.066 1.31l1.84.599-1.137 1.565a1.5 1.5 0 1 0 2.428 1.764L13 18.552l1.137 1.566a1.5 1.5 0 0 0 2.428-1.764l-1.138-1.565 1.84-.599a1.499 1.499 0 0 0 .237-2.782 1.502 1.502 0 0 0-1.163-.07Zm13.89.962a1.5 1.5 0 0 0-1.89-.963l-1.841.598V12a1.5 1.5 0 1 0-3 0v1.935l-1.841-.598a1.502 1.502 0 0 0-1.993 1.543 1.5 1.5 0 0 0 1.067 1.31l1.84.599-1.138 1.565a1.5 1.5 0 1 0 2.428 1.764L25 18.552l1.137 1.566a1.501 1.501 0 0 0 2.428-1.764l-1.138-1.565 1.84-.599a1.5 1.5 0 0 0 .964-1.89Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
